export class SiteMigrateMessage {
  constructor(
    public accountId: string,
    public defaultDomain: string,
  ) {}
}
